(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jfg-gift-finder"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('jfg-gift-finder')) {
  customElements.define('jfg-gift-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const selects = [...this.querySelectorAll('select[data-group]')];
      const error = this.querySelector('[role="alert"]');
      const chooseMessage = error.textContent;
      let currentTags = [];
      try { currentTags = JSON.parse(this.dataset.tags || '[]') || []; } catch {}
      const legacyTags = [...(this.dataset.query || '').matchAll(/tag:"([^"\\]+)"/g)].map(match => match[1]);
      const selectedTags = currentTags.length ? currentTags : legacyTags;
      const knownTags = new Set(selects.flatMap(select => [...select.options].map(option => option.value)).filter(Boolean));
      const unsupported = selectedTags.some(tag => !knownTags.has(tag));
      for (const select of selects) {
        const option = [...select.options].find(option => option.value && selectedTags.includes(option.value));
        if (option) select.value = option.value;
      }
      const selectedOptions = () => selects.filter(select => select.value).map(select => select.selectedOptions[0]);
      const clearError = () => {
        error.hidden = true;
        error.textContent = chooseMessage;
        selects.forEach(select => select.removeAttribute('aria-invalid'));
      };
      const destination = () => {
        const handles = selectedOptions().map(option => option.dataset.handle);
        if (!handles.length || handles.some(handle => !handle)) return null;
        const url = new URL(this.dataset.base.replace(/\/$/, '') + '/' + handles.map(handle => encodeURIComponent(handle)).join('+'), location.origin);
        url.searchParams.set('view', 'jfg-gifts');
        return url;
      };
      selects.forEach(select => select.addEventListener('change', clearError));
      form.addEventListener('submit', event => {
        event.preventDefault();
        clearError();
        const url = destination();
        if (url) { location.assign(url.href); return; }
        error.hidden = false;
        selects[0].setAttribute('aria-invalid', 'true');
        selects[0].focus();
      });
      this.querySelector('.jfg-gf__reset').addEventListener('click', () => {
        location.assign(new URL(this.dataset.page || this.dataset.base, location.origin).href);
      });
      this.querySelectorAll('button').forEach(button => { button.disabled = false; });
      if (unsupported) {
        error.textContent = this.dataset.unavailable;
        error.hidden = false;
      } else if (legacyTags.length && !currentTags.length) {
        const url = destination();
        if (url) location.replace(url.href);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
